// src/components/store/sections/testimonials/TestimonialV97CyberverifiedCrimsonRose.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV97CyberverifiedCrimsonRose(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={97}
      archKey="cyber_verified"
      archLabel="Cyber Neon Verified"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
